'use es6';

import { Map as ImmutableMap } from 'immutable';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/FileManager';
const INIT_STATE = {
  urls: ImmutableMap({}),
  requestState: RequestState.NOT_REQUESTED
};
export function fileManager(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_FILE_MANAGER_URLS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_FILE_MANAGER_URLS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_FILE_MANAGER_URLS:
      return Object.assign({}, state, {
        urls: state.urls.merge(action.guidToUrlMap)
      });
    case Actions.FAIL_GETTING_FILE_MANAGER_URLS:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
}
export function files(state = {}, action) {
  switch (action.type) {
    case Actions.RECEIVE_FILE_BY_PATH:
      return Object.assign({}, state, {
        [action.path]: action.file
      });
    default:
      return state;
  }
}